import { useFormContext, Controller } from 'react-hook-form';
import { Switch } from '../ui/Switch';
import { Label } from '../ui/Label';
import { cn } from '../../lib/utils';

// ----------------------------------------------------------------------

interface Props {
  name: string;
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export default function RHFSwitch({ name, label, helperText, className, disabled }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={cn('space-y-1', className)}>
          <div className="flex items-center space-x-2">
            <Switch
              id={name}
              checked={field.value}
              onCheckedChange={field.onChange}
              disabled={disabled}
            />
            {label && (
              <Label htmlFor={name} className={cn('cursor-pointer', error && 'text-destructive')}>
                {label}
              </Label>
            )}
          </div>
          {(error || helperText) && (
            <p className={cn('text-sm', error ? 'text-destructive' : 'text-muted-foreground')}>
              {error ? error.message : helperText}
            </p>
          )}
        </div>
      )}
    />
  );
}
